import script from "./recaptcha.vue?vue&type=script&setup=true&lang=ts"
export * from "./recaptcha.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__